import { ADD_GOAL, BASE_URL, GOALS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ApiResponse } from "./auth";
import { IGoal } from "models/goal";

export async function getGoals(params: string = "") : Promise<ApiResponse<IGoal[]>> {
  const response = await axios.get(BASE_URL + GOALS + params);
  return response.data;
}


export async function addGoal(data: FormData) {
  const response = await axios.post(BASE_URL + ADD_GOAL, data,{
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
  return response.data;
}
export async function editGoal(data: FormData, id: string) {
  const response = await axios.patch(BASE_URL + GOALS + `\\${id}` , data ,{
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
  return response.data;
}

export async function deleteGoal(id: string) {
  const response = await axios.delete(BASE_URL + GOALS + `\\${id}`);
  return response.data;
}


export const GoalCells: HeadCell[] = [
  {
    id: "icon",
    numeric: false,
    disablePadding: false,
    label: "Icon",
    
  },
  {
    id: "goalQuestion",
    numeric: false,
    disablePadding: false,
    label: "Question",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
]